
import React, { useState } from 'react';
import { JobSearchForm } from './JobSearchForm';
import { JobSearchResultsList } from './JobSearchResultsList';
import { SavedJobsDisplay } from './SavedJobsDisplay';
import { ProcessingState } from './ProcessingState';
import { CredentialValidationStatus } from './CredentialValidationStatus';
import { useJobSearch } from '@/hooks/useJobSearch';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface JobSearchResultsProps {
  onCreateLead?: (job: any) => void;
}

export const JobSearchResults = ({ onCreateLead }: JobSearchResultsProps) => {
  const { 
    searchResults, 
    isLoading, 
    error, 
    processingDetails,
    searchJobs, 
    crawlJobDetails, 
    crawlingJobId,
    validateJobData,
    validatingJobId,
    savedJobs,
    isFetchingSavedJobs,
    saveJob,
    unsaveJob,
    isSavingJobId
  } = useJobSearch();

  const [activeTab, setActiveTab] = useState("search");

  return (
    <div className="space-y-6">
      <CredentialValidationStatus />
      
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="search">Job Search</TabsTrigger>
          <TabsTrigger value="saved">
            Saved Jobs ({savedJobs.length})
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="search" className="space-y-6">
          <JobSearchForm onSubmit={searchJobs} isLoading={isLoading} />
          
          {isLoading && processingDetails && (
            <ProcessingState 
              details={processingDetails}
            />
          )}
          
          {error && !isLoading && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <h3 className="text-red-800 font-medium mb-2">Search Error</h3>
              <p className="text-red-700 text-sm">{error}</p>
            </div>
          )}
          
          {!isLoading && !error && searchResults.length > 0 && (
            <JobSearchResultsList 
              results={searchResults}
              savedJobIds={savedJobs.map(sj => sj.job_search_result_id)}
              onSaveJob={saveJob}
              onUnsaveJob={unsaveJob}
              isSavingJobId={isSavingJobId}
              isUserLoggedIn={true}
              onMakeLead={onCreateLead}
            />
          )}
          
          {!isLoading && !error && searchResults.length === 0 && (
            <div className="text-center py-12 bg-gray-50 rounded-lg">
              <p className="text-gray-600">No search results yet. Use the form above to start searching for jobs.</p>
            </div>
          )}
        </TabsContent>
        
        <TabsContent value="saved" className="space-y-6">
          <SavedJobsDisplay 
            savedJobs={savedJobs}
            isFetchingSavedJobs={isFetchingSavedJobs}
            onUnsaveJob={unsaveJob}
            isSavingJobId={isSavingJobId}
            onMakeLead={onCreateLead}
            isUserLoggedIn={true}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};
